import { DrawerBase } from "@material/mwc-drawer/mwc-drawer-base";
import { styles } from "@material/mwc-drawer/mwc-drawer.css";
import { css } from "lit";
import { customElement } from "lit/decorators";

@customElement("taui-drawer")
export class TauiDrawer extends DrawerBase {
  static override styles = [
    styles,
    css`
      .mdc-drawer {
        border-right: 0;
      }
      .mdc-drawer-app-content {
        height: 100%;
        overflow: hidden;
      }
    `,
  ];
}

declare global {
  interface HTMLElementTagNameMap {
    "taui-drawer": TauiDrawer;
  }
}
